module.exports = __webpack_public_path__ + "img/scad_06.c3f7c1f2.jpg";